import React, { Component } from "react";
import "./TermsAndConditionsPopup.css";
import ContextConstructor from "../Context/ContextProvider";
import sendLogError from "../../sendLogError";
import { AuthContext } from "../../AuthProvider";

import logoMobileImg from "../../images/logoMobile.png";
import pdfIconImg from "../../images/pdfIcon.svg";
import downloadImg from "../../images/download.png";
import alertaCircleImg from "../../images/alertaCircle.png";

class TermsAndConditionsPopup extends Component {
  static displayName = TermsAndConditionsPopup.name;
  static contextType = ContextConstructor;
  static authContext = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      optInsChecked: {},
      allAccepted: false,
      isAccepting: false,
      isRejecting: false,
      pdfLoadError: false,
      showCloseConfirmation: false,
      isProcessingAction: false,
    };
  }

  componentDidMount() {
    const initialOptIns = {};
    if (this.props.termsData?.optIns) {
      this.props.termsData.optIns.forEach((optIn) => {
        initialOptIns[optIn.id] = false;
      });
    }
    this.setState({ optInsChecked: initialOptIns }, this.checkAllAccepted);
  }

  checkAllAccepted = () => {
    const { termsData } = this.props;
    const { optInsChecked } = this.state;
    const allAccepted = termsData?.optIns?.every((optIn) => optInsChecked[optIn.id]) ?? true;
    this.setState({ allAccepted });
  };

  handleOptInChange = (optInId) => {
    this.setState(
      (prevState) => ({
        optInsChecked: {
          ...prevState.optInsChecked,
          [optInId]: !prevState.optInsChecked[optInId],
        },
      }),
      this.checkAllAccepted,
    );
  };

  createApiPayload = (isAccepted) => {
    const { termsData } = this.props;

    return {
      isAccepted: isAccepted,
      termsVersion: termsData.currentVersion,
    };
  };

  handleRegisterAcceptance = async (payload) => {
    try {
      const { idToken } = this.context;

      if (!idToken) {
        throw new Error("Utilizador não autenticado.");
      }

      const response = await fetch("/Profile/RegisterTermsAcceptance", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMessage = "Falha ao registar a resposta dos termos.";
        throw new Error(errorMessage);
      }

      return response.json();
    } catch (error) {
      console.error("Error in handleRegisterAcceptance:", error);

      sendLogError(error.message, "handleRegisterAcceptance");

      throw error; // mantém comportamento original
    }
  };

  handleAccept = async () => {
    if (this.state.allAccepted && !this.state.isProcessingAction) {
      this.setState({ isAccepting: true, isProcessingAction: true });

      try {
        const payload = this.createApiPayload(true);
        await this.handleRegisterAcceptance(payload);

        setTimeout(() => {
          if (this.props.onClose) {
            this.props.onClose();
          }
        }, 500);
      } catch (error) {
        this.setState({ isAccepting: false, isProcessingAction: false });
      }
    }
  };

  handleReject = async () => {
    if (!this.state.isProcessingAction) {
      this.setState({ isRejecting: true, isProcessingAction: true });

      try {
        // const payload = this.createApiPayload(false);
        // console.log("Enviando recusa para a API:", payload);

        // await this.handleRegisterAcceptance(payload);

        // console.log("Termos recusados. A fazer logout...");
        this.context.handleLogout();
      } catch (error) {
        this.setState({ isRejecting: false, isProcessingAction: false });
      }
    }
  };

  handleCloseAttempt = () => {
    this.setState({ showCloseConfirmation: true });
  };

  handleConfirmClose = () => {
    this.setState({ showCloseConfirmation: false });
    this.handleReject();
  };

  handleCancelClose = () => {
    this.setState({ showCloseConfirmation: false });
  };

  getFullPdfUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    const baseUrl = window.location.origin;
    return `${baseUrl}${url}`;
  };

  getActiveDocument = () => {
    const { termsData } = this.props;
    if (!termsData?.documents || termsData.documents.length === 0) {
      return null;
    }
    return termsData.documents.find((doc) => doc.isValid === true) || null;
  };

  handleIframeError = () => {
    this.setState({ pdfLoadError: true });
  };

  handleIframeLoad = () => {
    this.setState({ pdfLoadError: false });
  };

  render() {
    const { termsData } = this.props;
    const {
      pdfLoadError,
      isAccepting,
      isRejecting,
      allAccepted,
      showCloseConfirmation,
      isProcessingAction,
    } = this.state;

    if (!termsData) return null;

    const sortedContentElements = termsData.contentElements
      ? [...termsData.contentElements].sort((a, b) => a.order - b.order)
      : [];

    const activeDocument = this.getActiveDocument();
    const pdfUrl = activeDocument ? this.getFullPdfUrl(activeDocument.url) : null;

    return (
      <>
        <div className="terms-popup-overlay">
          <div className="terms-popup-container">
            <div className="terms-popup-header">
              <div className="terms-header-logo">
                <img className="terms-popup-logo" src={logoMobileImg} alt="Logo" />
              </div>
              <div className="terms-header-title">TERMOS E CONDIÇÕES</div>
              <button
                className="terms-header-close"
                onClick={this.handleCloseAttempt}
                disabled={isProcessingAction}
                aria-label="Fechar">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18 6L6 18"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div className="terms-popup-content">
              {sortedContentElements.map((element) => {
                if (element.type === "title") {
                  return (
                    <h2 key={element.id} className="terms-popup-title">
                      {element.content}
                    </h2>
                  );
                }
                if (element.type === "text") {
                  return (
                    <p key={element.id} className="terms-popup-text">
                      {element.content}
                    </p>
                  );
                }
                return null;
              })}

              {activeDocument && pdfUrl && (
                <>
                  <div className="terms-popup-documents">
                    <div className="terms-document-item">
                      <img src={pdfIconImg} alt="PDF" width="24" height="24" />
                      <div style={{ flex: 1, marginLeft: "10px" }}>
                        <span style={{ color: "#333", fontSize: "14px" }}>
                          {activeDocument.name}
                        </span>
                        {activeDocument.fileSizeFormatted && (
                          <span style={{ marginLeft: "10px", color: "#666", fontSize: "12px" }}>
                            ({activeDocument.fileSizeFormatted})
                          </span>
                        )}
                        {activeDocument.version && (
                          <span style={{ marginLeft: "10px", color: "#999", fontSize: "11px" }}>
                            v{activeDocument.version}
                          </span>
                        )}
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            marginLeft: "10px",
                            color: "#ff5800",
                            fontSize: "12px",
                            textDecoration: "none",
                          }}>
                          <img
                            src={downloadImg}
                            alt="Download"
                            style={{
                              width: "12px",
                              height: "12px",
                              marginRight: "4px",
                              verticalAlign: "middle",
                            }}
                          />
                          Download
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="terms-embedded-pdf" style={{ marginTop: "20px" }}>
                    <div
                      style={{
                        padding: "10px",
                        background: "#f9f9f9",
                        borderRadius: "8px 8px 0 0",
                        border: "1px solid #ddd",
                        borderBottom: "none",
                        fontSize: "12px",
                        color: "#666",
                      }}></div>
                    <iframe
                      src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
                      width="100%"
                      height="800px"
                      title={activeDocument.name}
                      onLoad={this.handleIframeLoad}
                      onError={this.handleIframeError}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "0 0 8px 8px",
                        backgroundColor: "#ffffff",
                        display: "block",
                      }}
                    />
                  </div>
                </>
              )}

              {termsData.optIns && termsData.optIns.length > 0 && (
                <div className="terms-popup-optins">
                  {termsData.optIns.map((optIn) => (
                    <div key={optIn.id} className="terms-optin-item">
                      <input
                        type="checkbox"
                        id={`optin-${optIn.id}`}
                        checked={this.state.optInsChecked[optIn.id] || false}
                        onChange={() => this.handleOptInChange(optIn.id)}
                        className="terms-optin-checkbox"
                        disabled={isProcessingAction}
                      />
                      <label htmlFor={`optin-${optIn.id}`} className="terms-optin-label">
                        {optIn.text}
                        {optIn.isRequired && <span className="terms-optin-required"> *</span>}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              {termsData.currentVersion && (
                <div
                  style={{
                    marginTop: "20px",
                    padding: "10px",
                    background: "#f0f0f0",
                    borderRadius: "5px",
                    fontSize: "12px",
                    color: "#666",
                  }}>
                  <strong>Versão dos Termos e Condições:</strong> {termsData.currentVersion}
                  {termsData.termsDate && (
                    <span>
                      {" "}
                      | Data: {new Date(termsData.termsDate).toLocaleDateString("pt-PT")}
                    </span>
                  )}
                </div>
              )}
            </div>

            <div className="terms-popup-buttons">
              <button
                onClick={this.handleAccept}
                className={`terms-popup-accept ${!allAccepted || isProcessingAction ? "disabled" : ""}`}
                disabled={!allAccepted || isProcessingAction}>
                {isAccepting ? (
                  <span className="button-with-spinner">
                    <span className="spinner"></span>
                  </span>
                ) : (
                  "Aceitar"
                )}
              </button>
            </div>
          </div>
        </div>

        {showCloseConfirmation && (
          <div className="confirmation-modal-overlay">
            <div className="confirmation-modal">
              <div className="confirmation-modal-icon">
                <img src={alertaCircleImg} width="48px" height="px"></img>
              </div>
              <p className="confirmation-modal-text">
                A não aceitação destes Termos e Condições impede a utilização do serviço My
                Montepio.
              </p>
              <p className="confirmation-modal-subtext">
                Ao decidir sair, a sua sessão será terminada.
              </p>
              <div className="confirmation-modal-buttons">
                <button
                  className="botao voltar"
                  onClick={this.handleCancelClose}
                  disabled={isRejecting}>
                  Voltar
                </button>
                <button
                  className="confirmation-button-cancel-btt botao laranja"
                  onClick={this.handleConfirmClose}
                  disabled={isRejecting}>
                  {isRejecting ? (
                    <span className="button-with-spinner">
                      <span className="spinner"></span>
                    </span>
                  ) : (
                    "Sair"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default TermsAndConditionsPopup;
